import styled from '@emotion/styled';
import Theme from 'App.theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10% 20%;
`;

export const Main = styled.main`
  width: 100%;
  height: 100%;
  background-color: ${Theme.colours.primary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
